module.exports = __webpack_public_path__ + "img/item2videoico.7876b35d.png";